export const getPlaceType = (isHeaderButton: boolean, hasForcedContacts: boolean) => {
  if (hasForcedContacts) {
    return 'Open_jk_card_author_block';
  }

  return isHeaderButton ? 'Open_jk_card_blockStickytop' : 'Open_jk_card_blockJK';
};
